<template>
  <div class="source-software">
    <div class="header-box" id="headerBox">
      <layoutHeader :default-bg="'rgba(0,0,0,0.3)'" :scroll-bg="'#181818'" />
    </div>
    <div class="content">
      <div class="title">
        <img src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661418238312375205.png" alt="">
      </div>
      <div class="tab" ref="tab" id="softwareTab" :class="tabFixed ? 'tab-fixed':''">
        <template v-for="(item, index) in list">
          <div class="item" :class="index === tabIndex ? 'active' : ''"  @click="lookUp(index)" v-if="item.list.length > 0">
              {{ item.name }}
          </div>
        </template>
      </div>
      <div class="main">
        <div class="info" v-for="(item, index) in list" :id="item.id" v-if="item.list.length > 0">
          <div class="header">
            <div class="name">{{ item.name }}</div>
            <div class="name-en">{{ item.name_en }}</div>
          </div>
          <div class="list">
            <div class="main-container">
              <el-row :gutter="70">
                <template v-for="(software, key) in item.list">

                  <el-col :xs="24" :sm="12" :md="8" :lg="8">
                    <div class="item" :class="key ===currentIndex && index === currentTypeIndex ? 'active':''"
                         @mouseenter="onMouseEnter(index,key)"
                         @click="toDetail(software)"
                         @mouseleave="onMouseLeave()">
                      <el-image :src="software.softwareIcon" class="cover"></el-image>
                      <div class="version">{{ software.softwareVersion }}</div>
                      <div class="bottom">
                        <div class="software-name">{{ software.softwareName }}</div>
                        <i class="el-icon-right"></i>
                      </div>
                    </div>
                  </el-col>
                </template>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import router from "@/router";
import Model from '@/model/software'

export default {
  components: {
    layoutHeader,
  },
  name: 'layout',
  data() {
    return {
      tabFixed: false,
      tabIndex: 0,
      currentIndex: -1,
      currentTypeIndex: -1,
      list: [
        {
          name: "移动端",
          name_en: "MOBILES",
          top: 0,
          id: "mobile",
          list: []
        },
        {
          name: "设备端",
          name_en: "DEVICES",
          top: 0,
          id: "personal",
          list: []
        },
        {
          name: "插件",
          name_en: "PLUG_IN",
          top: 0,
          id: "plugin",
          list: []
        },
		{
		  name: "快应用",
		  name_en: "FAST_APP",
		  top: 0,
		  id: "fastapp",
		  list: []
		}
      ],
      tabTop: 0,
      tabHeight: 0,
      headerHeight: 0,
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
    setTimeout(() => {
      this.headerHeight = document.getElementById("headerBox").offsetHeight
      this.tabTop = document.getElementById("softwareTab").offsetTop
      this.tabHeight = document.getElementById("softwareTab").offsetHeight

      console.log('header', this.headerHeight, 'tab', this.tabTop)
      this.list.forEach(item => {
        item.top = document.getElementById(item.id).offsetTop - this.headerHeight - this.tabHeight
        console.log(item.id, item.top)
      })
    }, 500)
  },
  methods: {
    scrollToTop() {
      let that = this;
      that.tabFixed = window.pageYOffset > this.tabTop-this.headerHeight;
      for(let i = this.list.length - 1; i >= 0; i--) {
        const item = this.list[i]
        if (window.pageYOffset >= item.top) {
          this.tabIndex = i
          break;
        }
      }

    },
    lookUp(index) {
      index = parseInt(index)
      this.currentIndex = index
      const item = this.list[index]
      const top = item.top
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    async getList() {
      const res = await Model.getAllSoftware()
      if (res.code === 1) {
        this.list[0].list = res.data.mobileTerminalList
        this.list[1].list = res.data.personalComputerList
        this.list[2].list = res.data.pluginList
		    this.list[3].list = res.data.fastAppList
      }
    },
    onMouseEnter(key, index) {
      this.currentIndex = index
      this.currentTypeIndex = key
    },
    onMouseLeave() {
      this.currentIndex = -1
    },
    toDetail(item) {
      router.push({
        name: 'SourceSoftwareDetail',
        query: {
          name: item.softwareName,
          system: item.softwareType
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.source-software {
  background: #181818;
  border: 1px solid rgba(0,0,0,0);

  .header-box {
    top: 0;
    left: 0;
    width: 100%;
    position: fixed;
    z-index: 100;
  }

  .content {
    >.title {
      img{
        width: 100%;
      }
    }

    .tab {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      justify-content: center;


      .item {
        margin-right: 142px;
        line-height: 40px;
        cursor: pointer;
      }

      .active {
        color: #EB6100;
        border-bottom: 2px solid #EB6100;
      }
    }
    .tab-fixed{
      position: fixed;
      top: 80px;
      left: 0;
      width: 100%;
      background: #181818;
      z-index: 90;
    }
    .main {
      .header {
        text-align: center;
        color: #fff;
        font-weight: 500;
        padding-top: 70px;

        .name {
          font-size: 40px;
          margin-bottom: 15px;
        }

        .name-en {
          font-size: 24px;
        }
      }

      .list {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 40px;
        margin-bottom: 150px;

        .main-container{
          padding: 0 35px;
        }

        .item {
          margin-top: 60px;
          background: #202020;
          border-radius: 10px;
          text-align: left;
          box-sizing: border-box;
          padding: 45px 52px 45px;
          color: #FFFFFF;
          cursor: pointer;

          .cover {
            width: 118px;
            height: 118px;
            border-radius: 16px;
            border-image: linear-gradient(309deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
          }

          .version {
            font-size: 20px;
            color: #828080;
            margin-top: 35px;
            margin-bottom: 13px;
          }

          .bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .software-name {
              font-size: 28px;

            }

            .el-icon-right {
              font-size: 40px;
            }
          }
        }

        .item.active {
          color: #EB6100;

          .cover {
            box-shadow: 20px 10px 70px 0px rgba(235, 97, 0, 0.2);
          }
        }
      }
    }
  }


}
</style>
